export enum UserJourneyEvent {
  // Этап 1: Первичное знакомство
  /** Пользователь зашел на любую страницу сайта/приложения */
  PAGE_VIEW = 'page_view',
  /** Пользователь просмотрел демо или примеры использования */
  VIEW_DEMO = 'view_demo',
  /** Пользователь инициировал процесс регистрации (например, кликнул "Зарегистрироваться") */
  SIGN_UP_START = 'sign_up_start',
  /** Пользователь успешно завершил регистрацию */
  SIGN_UP_COMPLETE = 'sign_up_complete',
  /** Пользователь впервые вошел в систему после регистрации */
  FIRST_LOGIN = 'first_login',

  // Этап 2: Онбординг и активация
  /** Пользователь ввел email для регистрации и нажал "Продолжить" */
  SUBMIT_REGISTRATION_EMAIL = 'submit_registration_email',
  /** Пользователь ввел корректный код верификации и перешел к созданию пароля */
  VERIFICATION_SUCCESSFUL = 'verification_successful',
  /** Пользователь заполнил дополнительные данные профиля и нажал "Get Started" */
  FINISH_PROFILE_SUBMIT = 'finish_profile_submit',
  /** Пользователь просмотрел дашборд проектов */
  VIEW_PROJECTS_DASHBOARD = 'view_projects_dashboard',
  /** Пользователь создал доску (борд) */
  CREATE_BOARD = 'create_board',
  /** Пользователь создал первую доску (борд) */
  CREATE_FIRST_BOARD = 'create_first_board',
  /** Пользователь открыл уже существующую доску */
  VIEW_EXISTING_BOARD = 'view_existing_board',
  /** Пользователь впервые как-то взаимодействовал с картой */
  FIRST_MAP_INTERACTION = 'first_map_interaction',

  // Этап 3: Исследование функций
  /** Пользователь воспользовался поиском */
  USE_SEARCH = 'use_search',
  /** Пользователь использовал один из инструментов рисования */
  USE_DRAWING_TOOL = 'use_drawing_tool',
  /** Пользователь кликнул на участок на карте */
  SELECT_PARCEL = 'select_parcel',
  /** Пользователь открыл панель слоев */
  OPEN_LAYERS_PANEL = 'open_layers_panel',
  /** Пользователь разместил маркер на карте */
  PLACE_MARKER = 'place_marker',
  /** Пользователь создал геометрию (линию, полигон) */
  CREATE_GEOMETRY = 'create_geometry',
  /** Пользователь просмотрел информацию об участке */
  VIEW_PARCEL_INFO = 'view_parcel_info',
  /** Пользователь попытался добавить слой (не важно, платный или бесплатный) */
  ATTEMPT_ADD_LAYER = 'attempt_add_layer',

  // Этап 4: Обнаружение ценности
  /** Пользователь перешел на вкладку "General" в информации об участке */
  VIEW_GENERAL_TAB = 'view_general_tab',
  /** Пользователь перешел на вкладку "Market" */
  VIEW_MARKET_TAB = 'view_market_tab',
  /** Пользователь перешел на вкладку "Rundown" */
  VIEW_RUNDOWN_TAB = 'view_rundown_tab',
  /** Пользователь начал анализировать рыночные данные */
  ANALYZE_MARKET_DATA = 'analyze_market_data',
  /** Пользователю был показан paywall для доступа к рыночным данным */
  SHOW_MARKET_PAYWALL = 'show_market_paywall',
  /** Пользователь добавил бесплатный слой на карту */
  ADD_FREE_LAYER = 'add_free_layer',
  /** Пользователю был показан paywall для доступа к платному слою */
  SHOW_LAYER_PAYWALL = 'show_layer_paywall',

  // Этап 4.5: AI Репорты и анализ
  /** Пользователь начал создание AI репорта (нажал кнопку "Run Summary") */
  AI_REPORT_START = 'ai_report_start',
  /** Пользователь выбрал предустановленный тег/промпт для AI репорта */
  AI_REPORT_PRESET_PROMPT = 'ai_report_preset_prompt',
  /** AI репорт успешно сгенерирован (отслеживаем только техметаданные без содержимого для соблюдения приватности) */
  AI_REPORT_GENERATED = 'ai_report_generated',
  /** Произошла ошибка при генерации AI репорта */
  AI_REPORT_ERROR = 'ai_report_error',
  /** Ошибка, связанная с кредитами при генерации AI репорта */
  AI_REPORT_CREDIT_FAILED = 'ai_report_credit_failed',
  /** Пользователь просмотрел основной AI репорт */
  AI_REPORT_VIEW_MAIN = 'ai_report_view_main',
  /** Пользователь просмотрел анализ POI в AI репорте */
  AI_REPORT_VIEW_POI = 'ai_report_view_poi',
  /** Пользователь просмотрел анализ листингов в AI репорте */
  AI_REPORT_VIEW_LISTINGS = 'ai_report_view_listings',
  /** Пользователь просмотрел анализ окружения в AI репорте */
  AI_REPORT_VIEW_ENVIRONMENT = 'ai_report_view_environment',
  /** Пользователь просмотрел ответ на пользовательский вопрос в AI репорте */
  AI_REPORT_VIEW_USER_QUESTION = 'ai_report_view_user_question',

  // Этап 4.6: Премиум слои карты
  /** Пользователь добавил премиум слой */
  PREMIUM_LAYER_ADD = 'premium_layer_add',
  /** Премиум слой успешно загружен */
  PREMIUM_LAYER_LOADED = 'premium_layer_loaded',
  /** Ошибка загрузки премиум слоя */
  PREMIUM_LAYER_ERROR = 'premium_layer_error',
  /** Премиум слой не виден на текущем зуме */
  PREMIUM_LAYER_ZOOM_ISSUE = 'premium_layer_zoom_issue',
  /** Пользователь взаимодействовал с премиум слоем */
  PREMIUM_LAYER_INTERACT = 'premium_layer_interact',
  /** Пользователь переключил (включил/выключил) премиум слой */
  PREMIUM_LAYER_TOGGLE = 'premium_layer_toggle',

  // Этап 5: Конверсия
  /** Пользователь просмотрел страницу с тарифами */
  VIEW_PRICING = 'view_pricing',
  /** Пользователь выбрал конкретный тарифный план */
  SELECT_PLAN = 'select_plan',
  /** Пользователь перешел к процессу оплаты */
  START_PAYMENT = 'start_payment',
  /** Пользователь успешно завершил оплату */
  PURCHASE_COMPLETE = 'purchase_complete',
  /** Оплата не удалась */
  PAYMENT_FAILED = 'payment_failed',
  /** Запрос на покупку данных по участку */
  PLOT_DATA_PURCHASE_REQUEST = 'plot_data_purchase_request',
  /** Ошибка покупки данных по участку */
  PLOT_DATA_PURCHASE_FAILURE = 'plot_data_purchase_failure',
  /** Запрос на покупку аналитики по участку */
  PLOT_ANALYTICS_PURCHASE_REQUEST = 'plot_analytics_purchase_request',
  /** Ошибка покупки аналитики по участку */
  PLOT_ANALYTICS_PURCHASE_FAILURE = 'plot_analytics_purchase_failure',
  /** Успешная покупка аналитики по участку */
  PLOT_ANALYTICS_PURCHASE_SUCCESS = 'plot_analytics_purchase_success',
  /** Успешная покупка данных по участку */
  PLOT_DATA_PURCHASE_SUCCESS = 'plot_data_purchase_success',

  // Этап 6: Удержание
  /** Пользователь вернулся в продукт после перерыва */
  RETURN_VISIT = 'return_visit',
  /** Пользователь провел активную сессию */
  ACTIVE_SESSION = 'active_session',
  /** Пользователь создал новый контент (доска, геометрия и т.д.) */
  CREATE_CONTENT = 'create_content',
  /** Пользователь пригласил другого пользователя */
  INVITE_USERS = 'invite_users',

  // Дополнительные события взаимодействия с участками
  /** Пользователь кликнул на участок в платном проекте */
  PAID_PROJECT_PLOT_CLICK = 'paid-project-plot-click',
  /** Пользователь кликнул на участок в бесплатном проекте */
  FREE_PROJECT_PLOT_CLICK = 'free-project-plot-click',

  // Загрузка файлов
  /** Запрос на загрузку SHP файла */
  DOWNLOAD_SHP_REQUEST = 'download_shp_request',
  /** Успешная загрузка SHP файла */
  DOWNLOAD_SHP_SUCCESS = 'download_shp_success',
  /** Ошибка загрузки SHP файла */
  DOWNLOAD_SHP_FAILURE = 'download_shp_failure',
  /** Успешная загрузка файла */
  FILE_DOWNLOAD_SUCCESS = 'file_download_success',
  /** Ошибка загрузки файла */
  FILE_DOWNLOAD_FAILURE = 'file_download_failure',

  // AI Report events
  /** Клик на кнопку апгрейда в AI Report */
  AI_REPORT_UPGRADE_CLICK = 'ai_report_upgrade_click',

  // Языковые настройки
  /** Пользователь использует приложение с определенным языком */
  LANGUAGE_SELECTED = 'language_selected',
}

export interface TrackModel {
  name: UserJourneyEvent | string; // Allow string for backward compatibility
  elementValue?: string;
  elementText?: string;
  payload?: Record<string, any>; // For extra data
}

export interface InternalTrackModel extends TrackModel {
  projectId?: string;
  sessionId: string;
} 